import React, { useContext, useEffect, useState } from 'react';

import {
  View,
  Section,
  Grid,
  Stack,
  Alert,
  Divider,
  Link,
  Typography,
  makeStyles,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Action,
  Actions as UIActions,
  EditIcon,
} from '@gogame/components';
import { FormContext, FormField } from '@gogame/form';
import { useChildComponent } from '@gogame/hooks-ts';
import { rangePresets } from '@gogame/intl-ts';

import { CampaignDetails } from 'scenes/Campaigns/GGCampaigns/components/CampaignDetails';
import { CostModelFormEditExisting } from 'scenes/Campaigns/GGCampaigns/components/CostModelForm';
import { loadOpenPeriodCostModelCampaigns } from 'scenes/ApiIntegrations/sources/fields';

import { COST_MODELS_END_DATE } from './constants';

const useStyles = makeStyles(() => ({
  root: {
    marginTop: '8px',
  },
}));
export default () => {
  const { values, setFieldValue } = useContext(FormContext);

  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const [childComponent, openChildComponent] = useChildComponent();

  useEffect(() => {
    if (!values.affiliates?.length) {
      setData(null);
      setFieldValue(COST_MODELS_END_DATE, undefined);
      return;
    }
    setFieldValue(COST_MODELS_END_DATE, rangePresets.TODAY.value[0]);
    handleLoad();
  }, [values.affiliates]);

  const handleLoad = async () => {
    setLoading(true);
    const res = await loadOpenPeriodCostModelCampaigns({
      affiliates: values.affiliates,
    });
    setLoading(false);
    setData(res);
  };

  const handleOpenCampaign = ({ id }) => {
    openChildComponent(CampaignDetails, {
      id: id,
      onExited: () => {
        return handleLoad();
      },
    });
  };
  const handleOpenCostModel = ({ costModelId, campaignId }) => {
    openChildComponent(CostModelFormEditExisting, {
      campaignId: campaignId,
      id: costModelId,
      onExited: () => {
        handleLoad();
      },
    });
  };

  if (!data?.length) {
    return null;
  }

  return (
    <React.Fragment>
      <Stack spacing={3} className={classes.root}>
        <Grid item xs={12}>
          <Alert severity={'warning'}>
            Some of affiliate’s campaigns have open cost models periods. Set end
            dates of these periods before creating the partner API.
          </Alert>
        </Grid>

        <Grid item xs={4}>
          <FormField.DatePicker
            required
            label={'Cost Model end date'}
            minDate={new Date(rangePresets.LAST_30_DAYS.value[0])}
            maxDate={new Date(rangePresets.TODAY.value[0])}
            name={COST_MODELS_END_DATE}
            padding={0}
          />
        </Grid>
        <Grid item xs={12}>
          <Divider />

          <Section
            title={`Campaigns Open Cost Periods ${
              data ? '(' + data.length + ')' : ''
            }`}
          >
            <View loading={loading}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell col={'name'}>Name</TableCell>
                      <TableCell col={'cost_model'} width={'110px'}>
                        Cost Model
                      </TableCell>
                      <TableCell col={'action'} width={'78px'}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.map((item) => {
                      return (
                        <TableRow>
                          <TableCell>
                            <Link
                              onClick={() =>
                                handleOpenCampaign({
                                  id: item.campaign.id,
                                })
                              }
                            >
                              <Typography variant={'body2'}>
                                {item.campaign.name}
                              </Typography>
                            </Link>
                          </TableCell>
                          <TableCell>
                            <Typography variant={'body2'}>
                              {item.name}
                            </Typography>
                          </TableCell>
                          <TableCell padding={'actions'}>
                            <UIActions limit={1} edge={'start'}>
                              <Action
                                id={'edit'}
                                label={'Edit'}
                                icon={<EditIcon />}
                                padding={0}
                                onClick={() =>
                                  handleOpenCostModel({
                                    costModelId: item.id,
                                    campaignId: item.campaign.id,
                                  })
                                }
                              />
                            </UIActions>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </View>
          </Section>

          <Divider />
        </Grid>
      </Stack>
      {childComponent}
    </React.Fragment>
  );
};
